<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 15:39:08
 * @LastEditTime: 2024-12-23 16:50:30
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 国内外大屏展示数据弹出页
 * @FilePath: \web\src\components\DataManager\MiningCompany\screenData.vue
-->
<template>
  <section class="screen-data-container">
    <section class="data-header">
      <div class="crud-wrapper" v-if="detailOperationConf.includes(config.getPermissionId())">
        <!-- <div
          class="crud-item crud-item-abled"
          @click="updateData()"
        >
          更新
        </div> -->

        <!-- <div
          class="crud-item crud-item-abled"
          @click="back()"
        >
          返回
        </div> -->
      </div>
    </section>
    <a-table rowKey="id" class="screen-data-table" :dataSource="screenDataPages" :loading="screenDataPagesLoading"
      :columns="detailColumns" @change="detailChangePage" :scroll="{ y: '96%' }" :pagination="detailPaginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template v-for="col in ['price', 'date', 'remark']" #[col]="{ text, record }" :key="col">
        <template v-if="!record.isEdit">
          <span>{{ text }}</span>
        </template>
        <template v-else>
          <a-input v-show="col === 'price' || col === 'remark'" v-model:value="record[col]" />
          <a-date-picker v-show="col === 'date'" v-model:value="record.date" format="YYYY-MM-DD" />
        </template>
      </template>
      <template #action="{ record, index }">
        <section class="action-icons">
          <i v-for="(item, i) in detailTableOperationList" :key="i" v-bind="item.option"
            @click="item.click(record, index)"
            :style="{ color: (item.option.title === '上移' && index <= 0 || item.option.title === '下移' && index === screenDataPages.length - 1) ? 'rgba(255, 200, 120, 0.6)' : 'rgb(255, 200, 120)', }">
          </i>
        </section>
      </template>
    </a-table>
    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
      </template>
    </Modal>
  </section>
</template>

<script setup>
import { message, } from 'ant-design-vue';
import { useStore, } from 'vuex';
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, defineProps, } from 'vue';
import { screenTableConfig, } from './tableConfig.js';
import { getCompanyPageApi, companyUpdateApi, } from '@/api/bigScreen/miningCompany';
import { GET_MINING_COMPANY_SCREEN_PAGE, } from '@/store/modules/actions/screenDataManager';
import config from '@/config/config';
import Modal from '@/components/lib/Modal/modal1.vue';
import moment from 'moment';

const props = defineProps({
  headerInfo: {
    type: Array,
  },
});

const detailColumns = screenTableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const miningCompanyState = computed(() => state.miningCompany);
const { screenTotalCount, screenRequestParams, screenDataPages, screenDataPagesLoading, } = toRefs(
  miningCompanyState.value
);
const commit = (space, methods, params) => storeCommit(`${space || 'miningCompany'}/${methods}`, params);
const dispatch = (space, methods, params) => storeDispatch(`${space || 'miningCompany'}/${methods}`, params);


// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  selectValue: [],
});

const selectedKeys = ref([]); // 表格选中id

const detailPaginationOption = computed(() => ({
  total: screenTotalCount.value,
  pageSize: screenRequestParams.value.size,
  current: screenRequestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

/**
 * @description 表格选中事件
 */
const detailRowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};

const addRecord = (record, index) => {
  let msg = '', flag = true;

  screenDataPages.value.forEach((item, i) => {
    if (item.isAdd) {
      msg = '请先保存或取消您正在新增的数据';
      flag = false;
      return;
    }
    if (item.isEdit) {
      msg = '请先保存或取消您正在编辑的数据';
      flag = false;
      return;
    }
  });

  if (!flag) {
    return message.info(msg);
  }
  let addObj = {
    price: '',
    date: '',
    remark: '',
    isEdit: true,
    isAdd: true,
  };

  screenDataPages.value.splice(index, 0, addObj);
};
const editRecord = (record, index) => {
  let msg = '', flag = true;

  screenDataPages.value.forEach((item, i) => {
    if (item.isAdd) {
      msg = '请先保存或取消您正在新增的数据';
      flag = false;
      return;
    }
    if (item.isEdit) {
      msg = '请先保存或取消您正在编辑的数据';
      flag = false;
      return;
    }
  });

  if (!flag) {
    return message.info(msg);
  }
  record['old'] = JSON.parse(JSON.stringify(record)); // 备份原始数据
  record.isEdit = true;
};

/* 查询 */
const detailSearchHandle = () => {
  dispatch(null, GET_MINING_COMPANY_SCREEN_PAGE);
};

// 勾选编辑
const selectEdit = () => {
  let record = screenDataPages.value.find(item => item.id === selectedKeys.value[0]);

  editRecord(record);
};
// 取消数据修改
const cancelRecord = (record, index) => {
  if (record.isAdd) {
    screenDataPages.value.splice(index, 1);
  } else {
    for (let i in record.old) {
      record[i] = record.old[i];
    }
    record.isEdit = false;
  }
};
// 保存数据修改
const saveRecord = (record, index) => {
  record.isEdit = false;
  record.isAdd = false;
  record.date = moment(record.date).format('YYYY-MM-DD');
};
// 开始删除
const delInfo = (record) => {
  record.shows = '0';
  companyUpdateApi(record).then(res => {
    confirmModalConf.visible = false;
    detailSearchHandle();
  });
};
// 单行数据删除之前
const beforeDel = (record) => {
  confirmModalConf.title = '确认移除大屏展示数据？';
  confirmModalConf.callback = () => delInfo(record);
  confirmModalConf.visible = true;
};

// 单行删除（数据移除大屏展示）
const delRecord = (record) => {
  beforeDel(record);
};

// 数据上移
const upRecord = (record, index) => {
  if (index <= 0) {
    console.log('已经是第一条了');
  } else {
    let updata = screenDataPages.value[index - 1];

    screenDataPages.value.splice(index - 1, 1);
    screenDataPages.value.splice(index, 0, updata);
  }
};
// 数据下移
const downRecord = (record, index) => {
  if (index === screenDataPages.value.length - 1) {
    console.log('已经是最后一条了');
  } else {
    let downdata = screenDataPages.value[index + 1];

    screenDataPages.value.splice(index + 1, 1);
    screenDataPages.value.splice(index, 0, downdata);
  }
};
// 详情页编辑、删除的权限控制
const detailOperationConf = [1, 2,];

const detailTableOperationList = ref([]);

const detailTableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangshang',
      title: '上移',
    },
    click: upRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangxia',
      title: '下移',
    },
    click: downRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2,],
  },
];

// 更新数据
const updateData = () => {
  detailSearchHandle();
};

// 返回
const back = () => { };

// 详情页页码change事件
const detailChangePage = (page) => {
  commit(null, 'setScreenRequestParams', { page: page.current, size: page.pageSize, });
  detailSearchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.title = '';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

onBeforeMount(() => {
  detailTableOperationList.value = detailTableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  detailSearchHandle();
});

</script>

<style lang='scss'>
.screen-data-container {
  .data-header {
    margin: 0.1rem;
    display: flex;
    justify-content: flex-end;

    .crud-wrapper {
      display: flex;

      // height: 0.51rem;
      // padding: 0.13rem 0.1rem;
      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式修改 */
  .screen-data-table {
    height: calc(100% - 0.84rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #FFC44D;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>